export const SSO_DEVICE_INFO_KEY = '__sso_web_device_info';
